import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import DataTable from "react-data-table-component";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import PopupAgregarCuentaCabal from "./PopupAgregarCuentaCabal";
import PopupAgregarCuentaBasa from "./PopupAgregarCuentaBasa";
import CuentaExternaService from "../../../../services/transferencias/CuentaExternaService";
import AliasService from "../../../../services/transferencias/AliasService";
import PopupAgregarCuentaTercero from "./PopupAgregarCuentaTercero";
import PopupAgregarAlias from "./PopupAgregarAlias";
import $ from "jquery";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass, faFilter, faEraser, faBan, faTrashCan,faSearch, faPlus} from "@fortawesome/free-solid-svg-icons";

const intermediario = {
  CABAL: "CABAL",
  BASA: "BASA",
  CU: "CU"
};

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

//CuentaSocio
export default class ListaAlias extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.lovFilter1 = React.createRef();
    this.lovFilter2 = React.createRef();
    this.lovFilter3 = React.createRef();
    this.lovFilter4 = React.createRef();
    this.lovFilter5 = React.createRef();
    this.entidadSelected = undefined;

    this.columns = [
      
      { id: 'id',
        name: "Id",
        selector: "id",
        omit: 'id',
      },
      {
        name: "Alias",
        selector: row => row.alias,
        sortable: true,
      },
      {
        name: "Tipo de Alias",
        selector: row => row.tipoAlias,
        sortable: true,
        width: "200px"
      },
      {
        name: "Nro. de Cuenta",
        selector: row => row.nroCuenta,
        sortable: true,
      },
      
      {
        cell: (row) => (
          <div>
           
            <button id={row.id} className="btn btn-tool" style={{ paddingLeft: 15 }} value={row.id}
              onClick={(e) => {
                var deleteThisItem = e.currentTarget.value;
                Popup.create({
                  title: "Confirmación",
                  content: "¿Está seguro que desea eliminar este alias?",
                  buttons: {
                    right: [
                      {
                        text: "Cancelar", className: "secundary",
                        action: function () {
                          Popup.close();
                        },
                      },
                      {
                        text: "Aceptar", className: "success",
                        action: () => {
                          this.deleteRegistroAlias(row.alias, row.tipoAlias);
                          Popup.close();
                          
                        },
                      },
                    ],
                  },
                });
              }} >
                <FontAwesomeIcon className="item-trash" icon={faTrashCan} value={row.id} style={{ paddingBottom: 9 }} >{" "}</FontAwesomeIcon> 
            </button>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      }
      
    ];
  
  }

  componentDidMount() {
   
    this.getCuentasExternas();
    this.getTiposDocumentos();
    //this.getEntidades();
    this.listadoAlias();
  }

  

  getInitialState = () => ({
    cuentasExternas: [],
    cuentasExternasFiltrado: [],
    entidades: [],
    listaPlan: [],
    tiposDocumentos: [],
    cuentaDestino: undefined,
    eliminarAlias: "",
    eliminarTipoAlias:""
  });

  // ################### SERVICIOS ###################### //
  getCuentasExternas(cuentaDestino = undefined) {
    trackPromise(
      CuentaExternaService.getCuentasExternas(this.props.intermediario).then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === "0") {
          var items = jData.datos;
          for (var i = 0; i < items.length; i++) {
            respuesta.push({
              id: items[i].id,
              titular: items[i].nombreDestino,
              entidad: items[i].entidad,
              nroCuenta: items[i].cuentaDestino,
              codEntidad: items[i].codigoEntidad,
              tipoDocDestino: items[i].tipoDocumento,
              docDestino: items[i].numeroDocumentoDestino,
              destinatario: items[i].destinatario
            });
          }
        }

        //ordenar elementos de menor a mayor, segun id
        respuesta.sort(function (a, b) {
          if (a.id > b.id) {
            return 1;
          }
          if (a.id < b.id) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

        this.setState({ ...this.state, cuentasExternas: respuesta, cuentasExternasFiltrado: respuesta });

        //console.log($(`[nro-cuenta=${cuentaDestino}]`));

        if (cuentaDestino) {
          $(`input[cuenta=${cuentaDestino}]`).trigger("click");
          respuesta.forEach(element => {

            if (element.nroCuenta == cuentaDestino) {
              //console.log("elemento seleccionado", element);
              this.entidadSelected = element;
              this.props.selectCuentaExterna(element);
              return;
            }
          });
        };

      })
    ).catch(function (error) {
      console.log(error);
    });

    return this.state.cuentasExternas;
  }
  
  deleteRegistroAlias = (alias, tipoAlias) => {
    trackPromise(
      AliasService.getEliminarAlias(alias, tipoAlias).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === "0") {
          Popup.queue(this.notifiPopup("Info", "Alias eliminado exitosamente"));
          Popup.close();
          window.location.reload();
          
        } else {
          
          Popup.queue(this.notifiPopup("Info", "Ocurrio un error al momento de eliminar el alias"));
          Popup.close();
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  listadoAlias(){
    var respuestaAlias = [];
    trackPromise(
      AliasService.getListadoAlias().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        
        if (jData.codigoRetorno === "0") {
          var items = jData.datos;
          for (var i = 0; i < items.length; i++) {
            respuestaAlias.push({
              id: items[i].idPersona,
              alias: items[i].alias,
              tipoAlias: items[i].tipoAlias,
              nroCuenta: items[i].idAhorro,
              estado: items[i].estado,
              
            });
          }
        }

        this.setState({ listaAlias: respuestaAlias });
        return this.state.listaAlias;
       
      })
    ).catch(function (error) {
      console.log(error);
    });
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              
              
            },
          },
        ],
      },
    });

  addCuentaCallback = (data) => {
    //console.log("add cuenta sin objeto");
    if (data === "OK") {
      this.getCuentasExternas();
    }
  };

  addCuentaTerceroCallback = ({ response, data }) => {
    //console.log("add cuenta objeto");
    if (response === "OK") {
      this.setState({
        ...this.state,
        cuentaDestino: parseInt(data)
      });
      //console.log("add cuenta...");
      this.getCuentasExternas(data);
    }
  };




  // ################### TABLA DE CUENTAS EXTERNAS ####################//
  getColumn() {
    return [
      {
        cell: (row) => {
          return (
            <div>
              <input ref={() => this.entidadSelected} id={"radio_" + row.id} key={row.id}
                type="radio" name="rowRadio" value={row.id} onClick={this.handleSelectRadioBtn}
                defaultChecked={(row.alias === this.state.listadoAlias) ? true : false} >
              </input>
              <button id={row.alias} className="btn btn-tool" style={{ paddingLeft: 15 }} value={row.alias}
                onClick={(e) => {
                  var deleteThisItem = e.currentTarget.value;
                  Popup.create({
                    title: "Confirmación",
                    content: "¿Está seguro que desea eliminar la cuenta",
                    buttons: {
                      right: [
                        {
                          text: "Cancelar", className: "secundary",
                          action: function () {
                            Popup.close();
                          },
                        },
                        {
                          text: "Aceptar", className: "success",
                          action: () => {
                            this.deleteRegistroAlias(row.alias, row.tipoAlias);
                            Popup.close();
                          },
                        },
                      ],
                    },
                  });
                }} >
               <FontAwesomeIcon className="item-trash" icon={faTrashCan} value={row.id} style={{ paddingBottom: 9 }} >{" "}</FontAwesomeIcon> 
              </button>
            </div>
          )
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        name: "Titular",
        selector: row => row.titular,
        sortable: true,
      },
      {
        name: "Entidad",
        selector: row => row.entidad,
        sortable: true,
        width: "200px"
      },
      {
        name: "Nro. de Cuenta",
        selector: row => row.nroCuenta,
        sortable: true,
      },
      {
        name: "Tipo de Documento",
        selector: row => row.tipoDocDestino,
        sortable: true,
      }, {
        name: "Nro. de Documento",
        selector: row => row.docDestino,
        sortable: true,
      }
    ];
  }

  seleccionarFila(row) {
    //console.log(row);
    var radio = document.getElementById("radio_" + row.id);
    radio.checked = true;
    //this.checkCuentaDestino();
    radio.click(this.selGrupoEvt);
  }

  handleSelectRadioBtn = (e) => {
    this.entidadSelected = e.currentTarget.value;
    let foundItems = this.state.listadoAlias.filter(
      item => item.id.toString() === this.entidadSelected.toString()
    );
    this.props.selectCuentaExterna(foundItems[0]);
  };

  // ################### FILTRO ###################### //
  campoFiltro(_refFilter, _refInput, _lovFilter) {
    return (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-12">
          <select ref={_lovFilter} defaultValue="" name="select" className="form-control input-box btn-consulta" >
            <option key="-1" value="" disabled> -- Seleccione-- </option>
            <option value="titular">Titular</option>
            <option value="entidad">Entidad</option>
            <option value="nroCuenta">Nro. de Cuenta</option>
            <option value="tipoDoc">Tipo de Documento</option>
            <option value="valueDoc">Valor Documento</option>
          </select>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <button className="btn btn-cu-secundary btn-consulta"
            onClick={() => {
              _refFilter.style.display = "none";
              _lovFilter.current.value = "";
              _refInput.value = "";
              this.handleBuscarBtn();
            }} >
          <FontAwesomeIcon icon={faBan} />  Eliminar Filtro
          </button>
        </div>
      </div>
    );
  }

  handleLimpiarBtn = (e) => {
    this.input1.value = "";
    this.input2.value = "";
    this.input3.value = "";
    this.input4.value = "";
    this.input5.value = "";
    this.lovFilter1.current.value = "";
    this.lovFilter2.current.value = "";
    this.lovFilter3.current.value = "";
    this.lovFilter4.current.value = "";
    this.lovFilter5.current.value = "";

    this.setState({ cuentasExternasFiltrado: this.state.cuentasExternas });

    this.checkCuentaDestino();
  };

  

  

  // getEntidades() {
  //   trackPromise(
  //     TransferInterbancaService.getEntidades().then((response) => {
  //       var data = JSON.stringify(response.data);
  //       var jData = JSON.parse(data);
  //       if (jData.codigo === 0) {
  //         this.setState({ entidades: jData.datos });
  //       }
  //     })
  //   ).catch(function (error) {
  //     console.log(error);
  //   });
  // }

  getTiposDocumentos() {
    trackPromise(
      TransferInterbancaService.getTiposDocumentos().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState({ tiposDocumentos: jData.datos });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  agregarCuentaExterna() {
    
        return (<PopupAgregarAlias />);

      
  }

  //TODO componente de prueba


  render() {

    //console.log("render cuenta externa...");

    return (
      <>
        {this.agregarCuentaExterna()}
        <div className="col-md-12">
          <div className="form-group">
            <div className="row">
              <div className="col-lg-8 col-md-6 col-12">
              <label className="input-label-bold">
             Lista de Mis Alias Registrados
            </label>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
              <button data-toggle="modal" data-target="#modal-alias" className="btn btn-cu-secundary btn-consulta">
              <FontAwesomeIcon icon={faPlus} /> Agregar nuevo alias
            </button>
            </div>
         
            </div>

          

            
          </div>

          {/* <div className="row">
            <div className="col-md-12">
              <div className="collapse" id="collapseExample">
                <div className="card card-body" >
                  <div className="row">
                    <div className="col-12">
                      <div ref={(div) => (this.filter1 = div)} className="row">
                    
                      
                      </div>

                      <div ref={(div) => (this.filter2 = div)} className="row" >
                        <div className="col-lg-4 col-md-12 col-12">
                          <div className="form-group">
                            <input ref={(input) => (this.input2 = input)}
                              type="text" name="entidad" className="form-control input-box" placeholder="Buscar" />
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-12">
                          {this.campoFiltro(this.filter2, this.input2, this.lovFilter2)}
                        </div>
                      </div>

                      <div ref={(div) => (this.filter3 = div)} className="row" >
                        <div className="col-lg-4 col-md-12 col-12">
                          <div className="form-group">
                            <input ref={(input) => (this.input3 = input)} type="number" name="nroCuenta"
                              className="form-control input-box" placeholder="Buscar" />
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-12">
                          {this.campoFiltro(this.filter3, this.input3, this.lovFilter3)}
                        </div>
                      </div>

                      <div ref={(div) => (this.filter4 = div)} className="row" >
                        <div className="col-lg-4 col-md-12 col-12">
                          <div className="form-group">
                            <input ref={(input) => (this.input4 = input)} type="text"
                              name="tipoDoc" className="form-control input-box"
                              placeholder="Buscar" />
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-12">
                          {this.campoFiltro(this.filter4, this.input4, this.lovFilter4)}
                        </div>
                      </div>

                      <div ref={(div) => (this.filter5 = div)} className="row" >
                        <div className="col-lg-4 col-md-12 col-12">
                          <div className="form-group">
                            <input ref={(input) => (this.input5 = input)}
                              type="text" name="valueDoc" className="form-control input-box"
                              placeholder="Buscar" />
                          </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-12">
                          {this.campoFiltro(this.filter5, this.input5, this.lovFilter5)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-12">
                    <button
                        className="btn btn-cu-primary btn-consulta"
                        onClick={() => {
                          if (
                            this.filter1 !== undefined &&
                            this.filter1.style.display === "none"
                          ) {
                            this.filter1.style.display = "";
                          } else if (
                            this.filter2 !== undefined &&
                            this.filter2.style.display === "none"
                          ) {
                            this.filter2.style.display = "";
                          } else if (
                            this.filter3 !== undefined &&
                            this.filter3.style.display === "none"
                          ) {
                            this.filter3.style.display = "";
                          } else if (
                            this.filter4 !== undefined &&
                            this.filter4.style.display === "none"
                          ) {
                            this.filter4.style.display = "";
                          } else if (
                            this.filter5 !== undefined &&
                            this.filter5.style.display === "none"
                          ) {
                            this.filter5.style.display = "";
                          }
                          this.checkCuentaDestino();
                        }} >
                      <FontAwesomeIcon icon={faFilter} />  Agregar Filtro
                      </button>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12">
                    <button type="submit" className="btn btn-cu-secundary btn-consulta" onClick={this.handleLimpiarBtn}>
                      <FontAwesomeIcon icon={faEraser} />  Limpiar Filtro
                      </button>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12">
                    <button type="submit" className="btn btn-cu-quintary" onClick={this.handleBuscarBtn} style={{ width: "100%" }}>
                      <FontAwesomeIcon icon={faMagnifyingGlass} /> Buscar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-md-12">
              <DataTable
                noHeader={true}
                pagination={true}
                //columns={this.getColumn()}
                columns={this.columns}
                data={this.state.listaAlias}
                dense={true}
                defaultSortFieldId="id"
                defaultSortAsc={false}
                paginationComponentOptions={paginationOptions}
                noDataComponent="No se han registrado alias hasta el momento."
                responsive={true}
                striped={true}
                onRowClicked={(e) => this.seleccionarFila(e)}
                pointerOnHover
              />
            </div>
          </div>
        </div>

      </>
    );
  }
}
